import { Box, Typography, Divider, Grid, TextField, ToggleButtonGroup, ToggleButton, FormControl, InputLabel, Select, MenuItem, FormHelperText, Button } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTaskContext } from "../../../../shared/context/taskContext"
import { useForm, Controller } from "react-hook-form"
import { useEffect } from "react"
import DropFiles from "../../../../shared/components/DropFiles"


export default function ResponseSubTasksComponent() {
    const theme = useTheme()
    const { subtaskList, subtaskResponse, setSubtaskResponse, stepActive, handleStep, handleStepBack } = useTaskContext()

    const { control, formState: { errors } } = useForm()


    useEffect(() => {
    }, [subtaskResponse])


    useEffect(() => {
        if (subtaskList.length > 0 && subtaskResponse.length === 0) {
            const initialResponses = subtaskList.map(subtask => ({
                order: subtask.order,
                description: subtask.description,
                value: null,
                code: subtask.code
            }));
            setSubtaskResponse(initialResponses);
        }

    }, [subtaskList])


    useEffect(() => {
        // Verify that responses match subtasks
        if (subtaskResponse.length > subtaskList.length) {
            // If there are more responses than subtasks, filter out extra responses
            const validResponses = subtaskResponse.filter(response => 
                subtaskList.some(subtask => subtask.code === response.code)
            );
            setSubtaskResponse(validResponses);
        }
    }, [subtaskResponse, subtaskList])


    const areRequiredFieldsFilled = () => {
        for (const subtask of subtaskList) {
            if (subtask.is_mandatory) {
                const response = subtaskResponse.find(item => item.code === subtask.code);
                if (!response || response.value === null || response.value === "" || (Array.isArray(response.value) && response.value.length === 0)) {
                    return false;
                }
            }
        }
        return true;
    };


    const fieldText = (subtask, typeField, onChange, required, code) => {
        return (
            <Controller
                control={control}
                name={`subtask_${code}`}
                rules={{ required: required }}
                render={({ field }) => (
                    <TextField
                        fullWidth
                        type={typeField}
                        {...field}
                        value={subtaskResponse.find(item => item.code === code)?.value || ""}
                        onChange={(e) => onChange(e.target.value)}
                        error={!subtaskResponse.find(item => item.code === code)?.value && required}
                        helperText={!subtaskResponse.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                    />
                )}
            />
        )
    }

    const fieldBoolean = (subtask, onChange, required, code) => {
        return (
            <Controller
                control={control}
                name={`subtask_${code}`}
                rules={{ required: required }}
                render={({ field }) => (
                    <>
                        <ToggleButtonGroup
                            value={subtaskResponse.find(item => item.code === subtask.code)?.value || ""}
                            exclusive
                            onChange={(e) => onChange(e.target.value)}
                            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
                            color="primary"
                        >
                            <ToggleButton value="SI" sx={{ flex: 1 }}>SI</ToggleButton>
                            <ToggleButton value="NO" sx={{ flex: 1 }}>NO</ToggleButton>
                            <ToggleButton value="N/A" sx={{ flex: 1 }}>N/A</ToggleButton>
                        </ToggleButtonGroup>
                        <FormHelperText error={!subtaskResponse.find(item => item.code === code)?.value && required}>
                            {!subtaskResponse.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                        </FormHelperText>
                    </>
                )}
            />
        )
    }

    const fieldList = (subtask, options, onChange, required, code) => {
        return (
            <FormControl fullWidth>
                <Controller
                    control={control}
                    name={`subtask_${code}`}
                    rules={{ required: required }}
                    render={({ field }) => (
                        <>
                            <Select
                                {...field}
                                onChange={(e) => onChange(e.target.value)}
                                value={subtaskResponse.find(item => item.code === code)?.value || ""}
                            >
                                {options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.value}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText error={!subtaskResponse.find(item => item.code === code)?.value && required}>
                                {!subtaskResponse.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                            </FormHelperText>
                        </>
                    )}
                />
            </FormControl>
        )
    }

    const fieldAttachment = (subtask, onChange, required, code) => {

        return (
            <FormControl fullWidth>
                <Controller
                    control={control}   
                    name={`subtask_${code}`}
                    rules={{ required: required }}
                    render={({ field }) => (
                        <>
                            <DropFiles multiple={false} onChange={(files) => onChange(files)} base64={true}/>
                            <FormHelperText error={!subtaskResponse.find(item => item.code === code)?.value && required}>
                                {!subtaskResponse.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                            </FormHelperText>
                        </>
                    )}
                />
            </FormControl>
        )
    }

    return (
        <Box sx={{ mb: "60px" }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: "16px", color: theme.palette.text.primary, textAlign: "center" }}>Respuesta de Subtareas</Typography>
            <Typography variant="h6" sx={{ fontSize: "14px", color: theme.palette.text.secondary, textAlign: "center" }}>
                Esta sección permite registrar las respuestas a las subtareas de la actividad completada.
            </Typography>
            <Divider />


            <Grid container spacing={2} columns={12} sx={{ marginTop: "20px" }}>
                <Grid item size={{ xs: 12, md: 6 }} sx={{ margin: "auto" }}>
                    <Grid container spacing={3} columns={12}>
                        {subtaskList.map((subtask, index) => (
                            <Grid item size={{ xs: 12 }} key={index}>
                                <Typography variant="h6" sx={{ fontWeight: 'semibold', fontSize: "16px", color: theme.palette.text.primary }}>{subtask.description}</Typography>
                                {
                                    (subtask.type_field === "text" || subtask.type_field === "number" || subtask.type_field === "date" || subtask.type_field === "datetime-local") &&
                                    fieldText(subtask, subtask.type_field, (value) => {
                                        setSubtaskResponse((prev) => {
                                            const newSubtaskResponse = [...prev]
                                            const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                            if (subtaskIndex !== -1) {
                                                newSubtaskResponse[subtaskIndex].value = value
                                            }
                                            return newSubtaskResponse
                                        })
                                    }, subtask.is_mandatory, subtask.code)
                                }
                                {
                                    subtask.type_field === "boolean" && fieldBoolean(subtask, (value) => {
                                        setSubtaskResponse((prev) => {
                                            const newSubtaskResponse = [...prev]
                                            const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                            if (subtaskIndex !== -1) {
                                                newSubtaskResponse[subtaskIndex].value = value
                                            }
                                            return newSubtaskResponse
                                        })
                                    }, subtask.is_mandatory, subtask.code)
                                }
                                {
                                    subtask.type_field === "list" && fieldList(subtask, subtask.options, (value) => {
                                        setSubtaskResponse((prev) => {
                                            const newSubtaskResponse = [...prev]
                                            const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                            if (subtaskIndex !== -1) {
                                                newSubtaskResponse[subtaskIndex].value = value
                                            }
                                            return newSubtaskResponse
                                        })
                                    }, subtask.is_mandatory, subtask.code)
                                }
                                {
                                    subtask.type_field === "file" && fieldAttachment(subtask, (value) => {
                                        setSubtaskResponse((prev) => {
                                            const newSubtaskResponse = [...prev]
                                            const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                            if (subtaskIndex !== -1) {
                                                newSubtaskResponse[subtaskIndex].value = value
                                            }
                                            return newSubtaskResponse
                                        })
                                    }, subtask.is_mandatory, subtask.code)
                                }

                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>



            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                <Button
                    variant="contained"
                    onClick={handleStepBack}
                    disabled={stepActive === 1}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Anterior
                </Button>

                <Button
                    variant="contained"
                    onClick={handleStep}
                    disabled={!areRequiredFieldsFilled()}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    Siguiente
                </Button>
            </Box>

        </Box>
    )
}